import { PapiAttachmentFile, PapiDeviation } from '@wix/da-papi-types';
import { ADDITIONAL_MEDIA_ID_PREFIX } from '../constants';
import { useEffect, useState } from 'react';
import { hasWindow } from '../../utils/browser';

/** Attempts to `scrollIntoView` the currentlyViewedImageSource and assumes
 *  the page has an id it can find. Returns boolean that's true if (roughly)
 *  still scrolling. Warning: somewhat unreliable */
export function useScrollToCurrentlyViewed(
  deviation: PapiDeviation,
  additionalMedia: PapiAttachmentFile[],
  currentlyViewedImageSource
): boolean {
  const [isScrolling, setIsScrolling] = useState<boolean>(true);
  useEffect(() => {
    // todo: another location where the reference (in runtime terms not react)
    // of the deviation object is changing over renders - so fix or memoize?
    const isCurrentlyViewingDeviation =
      currentlyViewedImageSource.deviationId === deviation.deviationId &&
      currentlyViewedImageSource['type'] === deviation.type;
    if (!currentlyViewedImageSource || isCurrentlyViewingDeviation) {
      setIsScrolling(false);
      return;
    }

    if (!hasWindow()) {
      return;
    }

    const index = additionalMedia.findIndex(m => m === currentlyViewedImageSource);
    const id = `${ADDITIONAL_MEDIA_ID_PREFIX}${index}`;
    const imageEl = document.getElementById(id);
    if (imageEl) {
      setIsScrolling(true);
      // todo: still an approximation
      // the problem is that: the ol grows as images load in
      //    and images not only don't load on mount, but the list doesn't load completely until user scrolls
      // if index is low, scrollDelay can be low
      // if index is high and length is high, it can still be low (bc the scroll and load race WITH each other)
      // if index is mid and length is high, delay needs to be high
      const scrollDelay = additionalMedia.length * 2 + 7 * index;
      setTimeout(() => {
        imageEl.scrollIntoView({ block: 'center', behavior: 'instant' });
      }, scrollDelay);
      setTimeout(() => {
        setIsScrolling(false);
      }, scrollDelay + 40);
    }

    // todo: deviation in deps another location where the reference (in
    // runtime terms not react) of the deviation object is changing over
    // renders - so fix or memoize?

    // since scroll-mode updates currentlyViewedImageSource while scrolling,
    // that system and the above system will fight each other if we include
    // currentlyViewedImageSource as a dep
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [additionalMedia, deviation.deviationId]);

  return isScrolling;
}
